import React, {
  useEffect,
  useState
} from 'react'

import {
  useParams,
  useNavigate
} from 'react-router-dom'

import axios from 'axios'
import { useSelector } from 'react-redux'



import {
  IoCheckmarkDoneCircle
} from 'react-icons/io5'

import {
  IoIosWarning
} from 'react-icons/io'


export default function VerifyEmail() {

  const { token } = useParams()

  const navigate =
    useNavigate()

  const { url } =
    useSelector(
      state => state
    )


  const [message, setMessage] =
    useState(null)

  const [error, setError] =
    useState(null)

  const [loading, setLoading] =
    useState(true)


  useEffect(() => {

    if (!token) {

      navigate(
        '/auth/signin',
        { replace: true }
      )

      return

    }


    const verifyEmail = async () => {

      try {

        setLoading(true)
        setError(null)


        const response =
          await axios.post(
            `${url}/auth/signup/${token}`
          )


        setMessage(
          response.data.message ||
          'Your email has been verified successfully.'
        )

        setTimeout(() => {
          navigate(
            '/auth/signin',
            { replace: true }
          )

        }, 1500)


      } catch (err) {

        console.error(
          'Email verification failed:',
          err
        )


        setError(
          err.response?.data?.detail ||
          err.response?.data?.message ||
          'We could not verify your email address.'
        )

      } finally {

        setLoading(false)

      }

    }


    verifyEmail()


  }, [
    token,
    navigate,
    url
  ])


  return (

    <div
      className="
        min-h-screen
        bg-[#F7F9FC]
        font-[Satoshi]
      "
    >

   


      <main
  className="
    min-h-screen
    px-5
    py-10
    lg:px-10
    flex
    items-center
    justify-center
  "
>

        <div
          className="
            w-full
            max-w-xl
          "
        >

          <div
            className="
              bg-white
              border
              border-gray-200
              rounded-3xl
              shadow-sm
              px-6
              py-10
              sm:px-10
              text-center
            "
          >


            {loading && (

              <>

                <div
                  className="
                    w-16
                    h-16
                    rounded-full
                    bg-green-50
                    flex
                    items-center
                    justify-center
                    mx-auto
                    mb-6
                  "
                >

                  <div
                    className="
                      w-7
                      h-7
                      border-[3px]
                      border-green-200
                      border-t-green-600
                      rounded-full
                      animate-spin
                    "
                  />

                </div>


                <p
                  className="
                    text-sm
                    font-semibold
                    text-green-600
                    mb-2
                  "
                >
                  EMAIL VERIFICATION
                </p>


                <h1
                  className="
                    text-2xl
                    sm:text-3xl
                    font-bold
                    text-gray-900
                  "
                >
                  Verifying your email
                </h1>


                <p
                  className="
                    text-gray-500
                    mt-3
                    leading-6
                  "
                >
                  Please wait while we confirm
                  your email address.
                </p>

              </>

            )}



            {!loading && message && (

              <>

                <div
                  className="
                    w-20
                    h-20
                    rounded-full
                    bg-green-50
                    flex
                    items-center
                    justify-center
                    mx-auto
                    mb-6
                  "
                >

                  <IoCheckmarkDoneCircle
                    className="
                      text-6xl
                      text-green-500
                    "
                  />

                </div>


                <p
                  className="
                    text-sm
                    font-semibold
                    text-green-600
                    mb-2
                  "
                >
                  EMAIL VERIFIED
                </p>


                <h1
                  className="
                    text-3xl
                    font-bold
                    text-gray-900
                  "
                >
                  You're all set
                </h1>


                <p
                  className="
                    text-gray-500
                    mt-3
                    leading-6
                  "
                >
                  Your email address has been verified successfully. Taking you to the sign in page...
                </p>


                <button
                  onClick={() =>
                    navigate(
                      '/auth/signin',
                      { replace: true }
                    )
                  }
                  className="
                    w-full
                    h-12
                    mt-8
                    rounded-xl
                    bg-green-600
                    hover:bg-green-700
                    text-white
                    font-semibold
                    transition
                  "
                >
                  Continue to sign in
                </button>

              </>

            )}



            {!loading && error && (

              <>

                <div
                  className="
                    w-20
                    h-20
                    rounded-full
                    bg-red-50
                    flex
                    items-center
                    justify-center
                    mx-auto
                    mb-6
                  "
                >

                  <IoIosWarning
                    className="
                      text-6xl
                      text-red-500
                    "
                  />

                </div>


                <p
                  className="
                    text-sm
                    font-semibold
                    text-red-500
                    mb-2
                  "
                >
                  VERIFICATION FAILED
                </p>


                <h1
                  className="
                    text-3xl
                    font-bold
                    text-gray-900
                  "
                >
                  We couldn't verify your email
                </h1>


                <p
                  className="
                    text-gray-500
                    mt-3
                    leading-6
                  "
                >
                  {error}
                </p>


                <button
                  onClick={() =>
                    navigate(
                      '/auth/signin',
                      { replace: true }
                    )
                  }
                  className="
                    w-full
                    h-12
                    mt-8
                    rounded-xl
                    bg-gray-900
                    hover:bg-gray-800
                    text-white
                    font-semibold
                    transition
                  "
                >
                  Back to profile
                </button>

              </>

            )}


          </div>


          <p
            className="
              text-center
              text-xs
              text-gray-400
              mt-5
            "
          >
            RentHub is a product of
            Rivmev Services.
          </p>

        </div>

      </main>

    </div>

  )

}